import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from "@ngrx/store";
import { Revisione53Reducer, STATE_KEY_REVISIONE53 } from "./revisione53.reducers";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(STATE_KEY_REVISIONE53, Revisione53Reducer)
    ],
})
export class Revisione53StoreModule {}
